import * as React from "react";
const SvgSendMessage = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -960 960 960", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M120-160v-240l320-80-320-80v-240l760 320z" }));
export default SvgSendMessage;
